export default __webpack_public_path__ + "static/laptop-1ae0d89a3bcd7ec1c04f1c9772b554af.svg";